import request from '@/utils/request'
// 管辖地分局
export function branchInfo(data) {
    return request({
        url:'/netbar/api/common/v1/getSubstation',
        method:'post',
        data
    })
}
// 派出所
export function PoliceList(data) {
    return request({
        url:'/netbar/api/common/v1/getPolice',
        method:'post',
        data
    })
}
// 文件上传
export function UploadFile(data) {
    return request({
        url:'/netbar/api/common/v1/upload_file',
        method:'post',
        data
    })
}
// 评价
export function Evaluate(data) {
    return request({
        url:'/netbar/api/evaluate/v1/save',
        method:'post',
        data
    })
}
// 评价回显
export function echoEvaluate(data) {
    return request({
        url:'/netbar/api/maintenance_form/v1/list_detail',
        method:'post',
        data
    })
}
// 文件上传
export function HTUploadFile(data) {
    return request({
        url:'/netbar/api/common/v1/pic_upload',
        method:'post',
        data
    })
}
// 设备离线详情
export function devicesOffline(data) {
    return request({
        url:'/netbar/api/equipment_status/v1/equipment_status_detail',
        method:'post',
        data
    })
}
// 通知通报
export function informBulletinDetail(data) {
    return request({
        url:'/netbar/api/inform_bulletin/v1/detail',
        method:'post',
        data
    })
}


